import React, { forwardRef } from "react";
import styled from "styled-components";

const Input = styled.input`
  && {
    all: unset;
    font-family: Inter, system-ui;
    font-size: 21px;
    font-weight: 400;
    line-height: 24px;
    color: #5f6368;
    text-align: center;
    padding: 0;
    height: 100%;
    width: 100%;
    transition: color 0.3s ease-out;

    &::placeholder {
      color: inherit;
      opacity: 0.75;
      font-size: 21px !important;
    }

    &.highlighted {
      color: #dc3545;
    }
  }
`;

interface ReportNameInputProps {
  name: string;
  setName: (name: string) => void;
  placeholder: string;
}

const ReportNameInput = forwardRef<HTMLInputElement, ReportNameInputProps>(
  (props, ref) => {
    const { name, setName, placeholder } = props;

    return (
      <Input
        ref={ref}
        type="text"
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        placeholder={placeholder}
        aria-label="Template name"
      />
    );
  }
);

export default ReportNameInput;
